import {Component, Input} from '@angular/core';
import {IconCode} from '../../../../enums/icon-code.enum';

@Component({
    selector: 'app-form-field-row',
    templateUrl: './form-field-row.component.html',
    styleUrls: ['./form-field-row.component.less']
})
export class FormFieldRowComponent {
    @Input() text: string;
    @Input() label: string;
    @Input() size = 8; // label size
    @Input() valueSize = 8; // input size for ex clauses
    @Input() tooltipClass: string;
    @Input() tooltip: string;

    iconCodes = IconCode;
}
